import { useCallback } from 'react';

export const useSettingsAreaSettings = () => {

  const getSettingsAreaSettings = useCallback(({
    homeClientEventProps,
    isRegDemo,
    demoOn
  }) => {

    const {
      pathViews,
      lastView,
      hceStates
    } = homeClientEventProps

    const {
      homeSettings_state,
      clientSettings_state,
      eventSettings_state,
      regSettings_state,
      demoSettings_state
    } = hceStates ?? {}

    let settings_currentArea;
    let settings_currentType;
    let settingsSourceType = 'normal';

    if (pathViews) {
      if (pathViews.events || lastView === 'events') {
        let _eventSettings = {};
        if (isRegDemo && !_.isEmpty(regSettings_state)) {
          _eventSettings = regSettings_state
          settings_currentType = 'reg'
        } else if (demoOn && !_.isEmpty(demoSettings_state)) {
          _eventSettings = demoSettings_state
          settings_currentType = 'demo'
        } else {
          _eventSettings = eventSettings_state
          settings_currentType = 'event'
        }
        settings_currentArea = _eventSettings ? _eventSettings.eventSettings : {}
        settingsSourceType = _eventSettings?.eventSettings?.settingsSourceType || 'normal'
      } else if (pathViews.clients || lastView === 'clients') {
        settings_currentArea = clientSettings_state ? clientSettings_state.clientSettings : {}
        settings_currentType = 'client'
        // console.log('settings_currentArea clients', settings_currentArea)
      } else {
        settings_currentArea = homeSettings_state ? homeSettings_state.homeSettings : {}
        settings_currentType = 'home'
      }
    }

    _.forEach(settings_currentArea, sca => {
      delete sca.id
    })

    return {
      settings_currentArea,
      time_stamp: settings_currentArea ? settings_currentArea.time_stamp : null,
      tss: Date.now(),
      settingsSourceType,
      settings_currentType
    }
  }, []);

  return { getSettingsAreaSettings }

}
